import EnrollmentFlowLayout from 'components/common/enrollment/EnrollmentFlowLayout';
import React, { useEffect } from 'react';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { useEmployerFormsPageStore } from 'store/pages/enrollment/employer-forms/pageStore';
import { RouteV2Id } from 'routes/routesConfigV2';
import { observer } from 'mobx-react-lite';
import EmployerFormsTable from './EmployerFormsTable';

// TESTING_POLICY: CYPRESS_ONLY

const EmployerFormsContent: React.FC = observer(() => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useEmployerFormsPageStore();

  useEffect(() => {
    void pageStore.getInitialData();
  }, []);

  return (
    <EnrollmentFlowLayout
      pageStore={pageStore}
      domainParams={{ groupId, periodId }}
      pageId={RouteV2Id.EMPLOYER_FORMS}
      pageFooter={{
        onComplete: pageStore.isEnrollmentPeriodNotEditable ? undefined : pageStore.onComplete,
        disableCompleteButton: !pageStore.isEveryFormCompleted,
        completeDisabledReason: !pageStore.isEveryFormCompleted ? 'All forms must be completed.' : undefined,
      }}
    >
      <EmployerFormsTable formInstances={pageStore.webFormInstances} loading={pageStore.isInitialDataLoading} />
    </EnrollmentFlowLayout>
  );
});

export default EmployerFormsContent;
